export const paymentMethodNote = 'Note, you will need to add a payment method to your account before we ship your MedBox.';
export const paymentMethodSuccessNote = 'Monthly payments will be begin once your first MedBox ships.';